import { getCookie } from "../utils/cookie";
import { postRequest } from "../utils/fetch";

export interface IDesign {
	readonly packshotUrl: string;
	readonly defaultOptions: string;
	readonly onWishlist: boolean;
}

interface IGetDesignRequest {
	productCode: string;
	designPredefinedProductName: string;
	pointOfSaleId: string;
	language: string;
	theme: string;
	mobile: boolean;
	alternativeIndex: boolean;
	pvc: string;
}

export async function getDesign(
	productCode: string,
	designPredefinedProductName: string,
	theme: string,
	pvc: string,
): Promise<IDesign> {
	const request = {
		productCode,
		designPredefinedProductName,
		pointOfSaleId: window.context.pointOfSaleId,
		language: window.context.language,
		theme: theme,
		mobile: false,
		alternativeIndex: getCookie("elastic") === "alternative",
		pvc,
	} as IGetDesignRequest;
	const res = await postRequest<IGetDesignRequest, IDesign>("apicore/dspapi/getdesign", request, {
		headers: { "Content-type": "application/json; charset=utf-8" },
	});
	return res as IDesign;
}
